import { useDataChange, useDataValue } from 'Simple/Data'

let SELECTED_COLOR = '#1e874c'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'board_icon_id',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'icon',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(id)
  }
}

export function getBorder(color, current_id, selected_id) {
  return current_id === selected_id ? SELECTED_COLOR : color
}
